import React from "react";
import _ from "lodash";
import moment from "moment";
import cx from "classnames";
import submit from "submit-form";
import DateInput from "../../../parts/inputs/date-input";

const {
  DATE_FORMATS: { DATE_YEAR_FORMAT },
} = require("../../../constants");

function View(props, { locals }) {
  const { query, activeExercises } = locals;

  const activeMonth = moment(query.month, DATE_YEAR_FORMAT);
  const dayRange = _.map(_.range(-3, 4), (i) =>
    activeMonth.clone().add(i, "months")
  );

  return (
    <div className="Program-Calendar">
      <div className="Sub-Header">
        <div className="Day-Slider">
          <div className="days">
            <a
              className="prev"
              href={`/actions/refresh?month=${activeMonth
                .clone()
                .add(-1, "months")
                .format(DATE_YEAR_FORMAT)}`}
            />

            {_.map(dayRange, (day) => {
              const fullday = day.format(DATE_YEAR_FORMAT);
              const active = fullday === _.get(query, "month");
              return (
                <a
                  key={fullday}
                  className={cx("day", { active })}
                  href={`/actions/refresh?month=${fullday}`}
                >
                  {day.format("MMM")}
                  <br />
                  {day.format("YYYY")}
                </a>
              );
            })}

            <a
              className="next"
              href={`/actions/refresh?month=${activeMonth
                .clone()
                .add(1, "months")
                .format(DATE_YEAR_FORMAT)}`}
            />
          </div>

          <form id="calendar-form-date" className="picker">
            <DateInput
              name="month"
              value={activeMonth}
              onChange={handleDayChange}
            />
          </form>
        </div>
      </div>

      <div className="Main ">
        {!_.isEmpty(activeExercises) &&
          _.chain(activeExercises)
            .sortBy("date")
            .groupBy(({ date }) => moment(date).format("YYYY-MM-DD"))
            .map((exercises, day) => {
              const date = moment(day, "YYYY-MM-DD");
              return (
                <div key={day} className="Workout">
                  <div className="day-label">
                    {date.format("dddd")}
                    <b>{date.format("MMM D")}</b>
                  </div>

                  <div className="details">
                    {_(exercises)
                      .sortBy("order")
                      .map((exercise) => {
                        const isAssistant = exercise.type == "assistant";
                        const primary = isAssistant
                          ? "Assistant"
                          : _.get(exercise, "primary");

                        // const isAssistant = primary === "assistant";
                        //primary === "assistant";

                        const equipped =
                          !isAssistant && _.some(exercise.sets, "equipped");
                        return (
                          <div
                            className={cx("Exercise", primary, { equipped })}
                            key={exercise._id}
                          >
                            <div className="head">
                              {_.capitalize(primary)}{" "}
                              {exercise.secondary &&
                                `(${_.capitalize(exercise.secondary)})`}
                            </div>
                          </div>
                        );
                      })
                      .value()}
                  </div>

                  <a href={`/dashboard/program-builder/?day=${day}`}></a>
                </div>
              );
            })}
      </div>
    </div>
  );
}

function handleDayChange(val) {
  const date = moment(val, "MMM DD, YYYY");
  submit("#_", { body: { month: date.startOf("month").format("YYYY-MM-DD") } });
}

const Calendar = (app) => {
  app.get("/calendar", async ({ req, res, locals, load }) => {
    const { query } = req;
    const user = locals.activeUser._id;
    _.defaults(query, { month: moment().format(DATE_YEAR_FORMAT) });
    await load("activeExercises", {
      start: moment(query.month, DATE_YEAR_FORMAT).startOf("month"),
      end: moment(query.month, DATE_YEAR_FORMAT).endOf("month"),
    });
    res.body = <View />;
  });
};

export default Calendar;
